import { useEffect,useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import { setFWv } from "../redux/chartoptions";
import IndividualComponentPopup from "./individualcomponentpopup";


function FWv(){
    
    const [showModal,setShowModal] = useState(false);

    const myData = useSelector(state => state.api);

    let current_FWv = myData.FWv[0];

        
        
        const dispatch = useDispatch();
        const checked = useSelector(state => state.chartOption.FWv)

        const showPopup = () =>{
            setShowModal(true);
        }
    
        const hidePopup = () =>{
            setShowModal(false);
        }
        

    return(
        <>
            <div className="parameter" id="fwv" onClick={showPopup}>                    
                <div className="label2">
                    <input type="checkbox" id="fwv" checked={checked} onChange={(e) => {dispatch(setFWv(e.target.checked))}} />
                    <label htmlFor="fwv" >FWv</label>
                </div>
                    
                <div className="parameter_ul">
                    <ul>
                        <li type="none">Current FWv : {current_FWv} <br/> </li>
                    </ul>
                </div>
            </div>
            {showModal && <IndividualComponentPopup hider={hidePopup} bgcolor={"#ff8989"} />}
        </>
    );
}

export default FWv;